/** Grymwyrd en español europeo: contenido marketing para la portada. */
export const homeEs = {
  'home.heroEyebrow': 'Un mundo vivo de horror y fantasía',
  'home.heroTitle': 'Entra en el Crepúsculo',
  'home.heroBody':
    'Grymwyrd es un mundo de gas, de horror gótico victoriano, donde el pueblo de Greywick, ahogado en niebla, oculta torres en ruinas, criptas de mansiones y rituales mejores dejados sin pronunciar. Forja un héroe, descorre los velos del Cataclismo y graba tu nombre en un mundo que recuerda.',
  'home.heroPlayCta': 'Juega ahora',
  'home.heroBrowseCta': 'Explorar la Enciclopedia',
  'home.heroQuickstartPrompt': '¿Aún no preparado para jugar? Consigue el Quickstart gratuito',
}
